export default "__VITE_ASSET__CCF7iMMY__"